import { Component } from '@angular/core';

@Component({
  selector: 'site-mobileSideMenu',
  templateUrl: './mobileSideMenu.component.html',
  styleUrls: ['./mobileSideMenu.component.css']
})
export class MobileSideMenu {
  
  private hideMobileSideMenu(): void
  {
    document.getElementById("mobileSideNav").style.width = "0px";
  }
  
}



// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/mobileSideMenu/mobileSideMenu.component.ts